const getEndpointPrefix = (addHypen = true): string => {
    const hypen = addHypen ? '-' : '';
    let endpointPrefix = `staging${hypen}`;

    if (typeof window !== 'undefined') {
        endpointPrefix =
            !window.location.host.includes('staging') &&
            !window.location.host.includes('testing') &&
            !window.location.host.includes('localhost')
                ? ''
                : window.location.host.includes('testing')
                ? `testing${hypen}`
                : `staging${hypen}`;
    }

    return endpointPrefix;
};

export const getEnv = (): string => {
    let env = 'testing';

    if (typeof window !== 'undefined') {
        env =
            !window.location.host.includes('staging') &&
            !window.location.host.includes('testing') &&
            !window.location.host.includes('localhost')
                ? 'production'
                : window.location.host.includes('staging')
                ? 'staging'
                : window.location.host.includes('localhost')
                ? 'localhost'
                : 'testing';
    }

    return env;
};

export const isProd = (): boolean => {
    return getEnv() === 'production';
};

export const getBuildEnv = (): string => process.env.BUILD_ENV ?? 'testing';

export const isProdBuild = (): boolean => getBuildEnv() === 'production';

export const FOSTER_API = ((): string => {
    if (getEnv() === 'localhost') {
        return process.env.NEXT_PUBLIC_FOSTER_API ?? 'http://localhost:8084';
    }
    return `https://${getEndpointPrefix()}foster.realmworkshop.co`;
})();
